import { render } from "./admin-stats-table.template.html?vue&type=template&id=68a3dbfb&scoped=true"
import script from "./AdminStatsTable.vue?vue&type=script&lang=ts"
export * from "./AdminStatsTable.vue?vue&type=script&lang=ts"

import "./AdminStatsTable.vue?vue&type=style&index=0&id=68a3dbfb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68a3dbfb"

export default script